<template>
	<page>
	    <module enable-flex>
    			<m-search ref="search" @search="searchHandle">
    				<c-form>
    					<c-form-item type="input" label="模板名称" name="template_name"></c-form-item>
    					<c-form-item type="checkbox" name="state" :options="templateState"></c-form-item>
    				</c-form>
    			</m-search>
    			<m-operate>
                	<c-button color="sys" icon="add" @click="navigateTo(`/app_style_temp_add`)">新增模板</c-button>
                </m-operate>
			<c-table ref="table" code="app_style_list">
				<c-table-column label="状态" name="state" width="80">
					<template v-slot="{data}">
					    <span v-if="data.state==0" style="color:red">{{stateName[data.state]}}</span>
					    <span v-if="data.state==1" style="color:darkgreen">{{stateName[data.state]}}</span>
					    <span v-if="data.state==2" style="color:#999">{{stateName[data.state]}}</span>
					</template>
                </c-table-column>
                <c-table-column label="模板名称" name="template_name" width="300"></c-table-column>
				<c-table-column label="生效时间" name="effective_time"  width="200"></c-table-column>
				<c-table-column label="启/禁用状态" name="enable_state" width="110">
				    <template v-slot="{data}">
				        <span v-if="data.enable_state==1" style="color:darkgreen">{{enableName[data.enable_state]}}</span>
				        <span v-if="data.enable_state==2" style="color:red">{{enableName[data.enable_state]}}</span>
					</template>
				</c-table-column>
				<c-table-column type="button" fixed="right" label="操作"  width="160">
					<template v-slot="{data}">
					    <c-table-button @click="navigateTo(`/app_style_temp_edit/${data.id}`)">编辑</c-table-button>
                        <c-table-button v-if="data.enable_state == 2" @click="editTemplateState(data,1)">启用</c-table-button>
                        <c-table-button v-if="data.enable_state == 1" @click="editTemplateState(data,2)">禁用</c-table-button>
                        <c-table-button v-if="data.state != 1" @click="deleteTemplate(data)">删除</c-table-button>
                    </template>
                </c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_app_style',
		data() {
			return {
			    templateState: [
                    {name: '未生效',value: 0},
                    {name: '生效中',value: 1},
                    {name: '已过期',value: 2}
                ],
				enableName: {
					1: '启用',
					2: '禁用'
				},
				stateName: {
					0: '未生效',
					1: '生效中',
					2: '已失效'
				}
			}
		},
		
		mounted() {
			this.$refs.search.search();
			// 例如在列表页定义一个方法，第一个参数为方法名，为了防止出现命名冲突，以{页面名.方法名}的结构命名
            this.$bus.$on('app_style_list.update', data => {
            	// 刷新列表
            	this.$refs.table.update();
            });
		},
		
		methods: {
			searchHandle(data) {
                this.$refs.table.load({
                    url: '/app/style/template/list',
                    data
                });
            },
            /**模板启禁用**/
            editTemplateState(data,enable_state) {
                this.$confirm({
                        text: '确定要'+(enable_state == 1 ? '启用' : '禁用')+'【'+data.template_name+'】吗？',  // 提示内容,
                        buttonName: '确定',  // 确定按钮文字
                        cancelButton: true,  // 是否显示取消按钮
                        resolve: () => {
                             this.request({
                                 url: '/app/style/template/edit/state',
                                 data: {
                                     id: data.id
                                 },
                                 loading: true,
                                 success: data => {
                                     this.$message({
                                         text: (enable_state == 1 ? '启用' : '禁用')+'成功'
                                     });
                                     data.enable_state = enable_state;
                                 }
                              });
                        },  // 确定按钮回调
                        cancel: () => {},  // 取消按钮回调
                    });
            },
            /**删除模板**/
            deleteTemplate(data) {
                this.$confirm({
                        text: '确定要删除【'+data.template_name+'】吗？',  // 提示内容,
                        buttonName: '确定',  // 确定按钮文字
                        cancelButton: true,  // 是否显示取消按钮
                        resolve: () => {
                             this.request({
                                 url: '/app/style/template/remove',
                                 data: {
                                     id: data.id
                                 },
                                 loading: true,
                                 success: data => {
                                     this.$message({
                                         text: '删除成功'
                                     });
                                     this.$refs.search.search();
                                 }
                              });
                        },  // 确定按钮回调
                        cancel: () => {},  // 取消按钮回调
                    });
            }
		}
	}
</script>